// extracted by mini-css-extract-plugin
export default {"ttsContent":"tts_ttsContent__fvlsw"};